module.exports = __webpack_public_path__ + "a4358b60b1.woff2";